// extracted by mini-css-extract-plugin
export var close = "appendageState-module--close--LP4pC";